import { render, staticRenderFns } from "./EditIABFCorpsPiece.vue?vue&type=template&id=6f70f15e&scoped=true"
import script from "./EditIABFCorpsPiece.vue?vue&type=script&lang=js"
export * from "./EditIABFCorpsPiece.vue?vue&type=script&lang=js"
import style0 from "./EditIABFCorpsPiece.vue?vue&type=style&index=0&id=6f70f15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70f15e",
  null
  
)

export default component.exports